module.exports = __webpack_public_path__ + "static/media/andrews_homepage.712a8656.png";